import { render, staticRenderFns } from "./select_cbdw.vue?vue&type=template&id=27b61e1c&scoped=true&"
import script from "./select_cbdw.vue?vue&type=script&lang=js&"
export * from "./select_cbdw.vue?vue&type=script&lang=js&"
import style0 from "./select_cbdw.vue?vue&type=style&index=0&id=27b61e1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b61e1c",
  null
  
)

export default component.exports